import { render, staticRenderFns } from "./ThePhonebook.vue?vue&type=template&id=21bd93c5&scoped=true"
import script from "./ThePhonebook.vue?vue&type=script&lang=js"
export * from "./ThePhonebook.vue?vue&type=script&lang=js"
import style0 from "./ThePhonebook.vue?vue&type=style&index=0&id=21bd93c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bd93c5",
  null
  
)

export default component.exports